<app-modal [title]="dictionaryService.get('TimeRange')" [(opened)]="isOpen" size="md" (closeTrigger)="close()">
  <form [formGroup]="rangeForm" (ngSubmit)="apply()">
    <div class="time-range-body">
      <div class="input-group">
        <label class="input-label">{{ dictionaryService.get('From') }}</label>
        <app-date-picker formControlName="from" name="from-date" size="md" [max]="toValue"
          [isError]="rangeForm.controls.from.invalid && rangeForm.controls.from.touched">
        </app-date-picker>
      </div>
      <div class="input-group">
        <label class="input-label">{{ dictionaryService.get('To') }}</label>
        <app-date-picker formControlName="to" name="to-date" size="md" [min]="fromValue"
          [isError]="rangeForm.controls.to.invalid && rangeForm.controls.to.touched">
        </app-date-picker>
      </div>
    </div>
    <div class="time-range-footer">
      <button type="submit" buttonTheme="primary" buttonType="regular" [disabled]="rangeForm.invalid">
        {{ dictionaryService.get('Change') }}
      </button>
    </div>
  </form>
</app-modal>